import React from 'react'
import Img from 'react-cool-img'
import { LINK_TO_INFO } from 'constants/links'
import { withLocalization, Text } from 'hocs/localization'
import loadingImage from './assets/home-hero-min.jpg'
import image from './assets/home-hero.jpg'
import * as styles from './Banner.scss'

interface IProps {
  t: Text,
}

const Banner: React.FC<IProps> = ({ t }) => (
  <div className={styles.root}>
    <div className={styles.background}>
      <Img
        placeholder={loadingImage}
        src={image}
      />
    </div>
    <div className={styles.content}>
      <div className='container'>
        <h2>{t('header')}</h2>
        <div className={styles.mainText}>{t('text1')}<sup>{t('rCircle')}</sup> {t('text2')}</div>
        <div className={styles.mainTextSmall}>
          <div>
            {t('home.actualSavings1')}
            <a href={LINK_TO_INFO} target='_blank' className={styles.link} >
              {t('home.link')}
            </a>
          </div>
          <div>{t('home.actualSavings2')}</div>
        </div>
      </div>
    </div>
  </div>
)

export default withLocalization('home.main.banner')(Banner)
